<div class="form-item" [ngClass]="'form-field-'+field.type">
  <div class="form-field-menu">
    <core-helpers-navigation-three-dots-menu
      [menu]="fieldMenu"
      (action)="onMenuClick($event)"
    ></core-helpers-navigation-three-dots-menu>
  </div>
  <div [ngClass]="{'invalid-field': field.label == ''}">
    <input type="text" [ngModel]="field.label" [placeholder]="placeholder" (ngModelChange)="onFieldChange($event)">
  </div>
  <div class="object-selector" *ngIf="items && items.length > 0; else catsLoading">
    <core-helpers-forms-key-select
      [label]="''"
      [options]="items"
      [placeholder]="'Select one category'"
      [optionSelected]="optionSelected"
      (actionSelectItem)="onSelectItem($event)"
    ></core-helpers-forms-key-select>
  </div>
  <ng-template #catsLoading>
    <div class="loader selector-dimmed">
      <div class="dimmed">
        <div class="dimmed_table_box"></div>
      </div>
    </div>
  </ng-template>
  <div class="field-mandatory">
    <core-helpers-forms-input-checkbox
      [label]="'Make field mandatory'"
      [form]="form"
      [defaultChecked]="field.mandatory"
      (checkedChange)="onMandatoryChange($event)"
    ></core-helpers-forms-input-checkbox>
  </div>
</div>